import WebViewer from '@pdftron/webviewer'
import {saveAnnotation} from '../dataSource/webViewer'

const webViewerSaveAnnotation = async (fileCategory, fileSeq) => {
	// const store = require('store')
	const instance = WebViewer.getInstance(document.getElementById('webviewer'))
	const {annotManager} = instance

	if (instance === null) {
		console.error("Cannot get the WebViewer Instance!")
		return
	}

	return (
		annotManager.exportAnnotations({ links: false, widgets: false }).then(xfdfString => {
			
			console.log("xfdfString: ", xfdfString)

			return (
				saveAnnotation({
					file_ref: fileSeq,
					file_cat: fileCategory,
					annotation: xfdfString
				}).then(res => {
					console.log("*****************************************************************************")
					console.log("Annotation Save and Publish Successful")
					console.log(res)
					console.log("*****************************************************************************")

					// result = res

					return res

					// annotationPublishActionHandleClose()
					// buildAlert({
					// 	// Alert Type: success, info, warning, error
					// 	type: "success",
					// 	title: "success Alert",
					// 	content: "The annotations have been saved and published"
					// })
				})
			)
		})
	)
}


export {webViewerSaveAnnotation}